import { connect } from 'react-redux';
import { DriversTableFilter } from '../components/DriversTableFilter';
import { changeDriverStatuses } from '../../../thunks/tableThunks';
import type { DriverStatus } from '../../../../../types';
import type { ThunkDispatch } from 'redux-thunk';
import { getDriverStatusesRtk } from '../../../appSlice';
import type { RootState } from '../../../../../configuration/setup/store';

export interface DriversTableFilterPropertiesFromState {
    driverStatuses: DriverStatus[];
}

export interface DriversTableFilterPropertiesFromDispatch {
    changeDriverStatuses: (driverStatuses: DriverStatus[]) => void;
}

export interface DriversTableFilterOwnProps {
    compactRows: boolean;
    gridLines: boolean;
    onToggleCompactRows: () => void;
    onToggleGridLines: () => void;
}

const mapStateToProps = (state: RootState): DriversTableFilterPropertiesFromState => ({
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
    driverStatuses: getDriverStatusesRtk(state as any),
});

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, any>): DriversTableFilterPropertiesFromDispatch => ({
    changeDriverStatuses: (driverStatuses: DriverStatus[]) => {
        dispatch(changeDriverStatuses(driverStatuses));
    },
});

export const DriversTableFilterContainer = connect(mapStateToProps, mapDispatchToProps)(DriversTableFilter);
